(function ($, window, undefined) {
    if (window.golfbox === undefined)
        window.golfbox = window.gb = {};

    var document = window.document,
		navigator = window.navigator,
		location = window.location,
		_ = window.golfbox;

    _.linq = function (_base) {
        return {
            any: function (args) {
                for (var i = 0; i < args.length; i++) {
                    if (args[i] === _base) {
                        return true;
                    }
                }
                return false;
            }
        };
    };

    Object.defineProperty(Array.prototype, "any", {
        enumerable: false,
        writable: false,
        value: function (func) {
            for (var i = 0; i < this.length; i++) {
                if (func(this[i])) {
                    return true;
                }
            }

            return false;
        }
    });

    Object.defineProperty(Array.prototype, "sum", {
        enumerable: false,
        writable: false,
        value: function (func) {
            let sum = 0;
            for (let i = 0; i < this.length; i++) {
                if (func) {
                    sum += (+func(this[i]));
                } else {
                    sum += (+this[i]);
                }
            }

            return sum;
        }
    });

    Object.defineProperty(Array.prototype, "max", {
        enumerable: false,
        writable: false,
        value: function (func) {
            let max = 0;
            for (let i = 0; i < this.length; i++) {
                if (func) {
                    max = Math.max(max, func(this[i]));
                } else {
                    max = Math.max(max, this[i]);
                }
            }

            return max;
        }
    });
})(jQuery, window);